import * as yup from 'yup';

import { AdminSettingsResponse } from '../../../types';

import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../utils';

import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';

import { useGetAdminSettings } from '../../../../queries';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { FormContent } from './components/FormContent';

export const SETTINGS_GROUP_NAME = 'import-absence';

const schema = yup.object({
  import_absence_dutyHourTypeId: yup.string().default(''),
  import_absence_dutyHourTypeIdPregnancy: yup.string().default(''),
  import_absence_type: yup.string().default('')
});

export const AbsenceImport = () => {
  const { data: absenceImports = [], isFetching } =
    useGetAdminSettings<AdminSettingsResponse>(SETTINGS_GROUP_NAME);

  const { isLoading, mutate: save } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: absenceImports[0]?.groupId,
    invalidateQueryKey: [SETTINGS_GROUP_NAME]
  });

  const settings = absenceImports[0] ?? undefined;

  const onSubmit = (data) => {
    const payload = {
      ...settings,
      settings: transformAdminSettingsToRequestValues(data, settings?.settings)
    };
    save(payload);
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={onSubmit}
      schema={schema}
      isFetching={isFetching}
      isLoading={isLoading}
      data={transformAdminSettingsToFormValues(settings)}
    >
      <FormContent />
    </AdminSettingsFormWrapper>
  );
};
